"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageSrc = void 0;
var ImageSrc;
(function (ImageSrc) {
    ImageSrc["ASCENDING"] = "/fmk/styles/images/sort-ascending.svg";
    ImageSrc["ACCORDION_COLLAPSE"] = "/fmk/styles/images/accordion-collapse.svg";
    ImageSrc["ATTENTION"] = "/fmk/styles/images/attention.svg";
    ImageSrc["BACK"] = "/fmk/styles/images/back-button.svg";
    ImageSrc["BURGER_MENU"] = "/fmk/styles/images/burger-menu.svg";
    ImageSrc["CALENDAR"] = "/fmk/styles/images/calendar.svg";
    ImageSrc["CHECKMARK"] = "/fmk/styles/images/checkmark.svg";
    ImageSrc["CHECKMARK_NO_CROP"] = "/fmk/styles/images/no_crop/checkmark.svg";
    ImageSrc["CLOSE"] = "/fmk/styles/images/close.svg";
    ImageSrc["COLLAPSE"] = "/fmk/styles/images/collapse.svg";
    ImageSrc["CODE"] = "/fmk/styles/images/code.svg";
    ImageSrc["COPY_CONTENT"] = "/fmk/styles/images/copy-content.svg";
    ImageSrc["DARK_SPINNER"] = "/fmk/styles/images/dark-spinner.svg";
    ImageSrc["DD"] = "/fmk/styles/images/dd.svg";
    ImageSrc["DD_PLUS"] = "/fmk/styles/images/dd-plus.svg";
    ImageSrc["DELETE"] = "/fmk/styles/images/delete.svg";
    ImageSrc["DISABLED"] = "/fmk/styles/images/disabled.svg";
    ImageSrc["DISABLED_NO_CROP"] = "/fmk/styles/images/no_crop/disabled.svg";
    ImageSrc["DOCUMENT"] = "/fmk/styles/images/document.svg";
    ImageSrc["DOSAGE"] = "/fmk/styles/images/dosage.svg";
    ImageSrc["EDIT"] = "/fmk/styles/images/edit.svg";
    ImageSrc["EFFECTUATED"] = "/fmk/styles/images/effectuated.svg";
    ImageSrc["EXPAND"] = "/fmk/styles/images/expand.svg";
    ImageSrc["FILTER"] = "/fmk/styles/images/filter.svg";
    ImageSrc["FMB_LOGO"] = "/fmk/styles/images/fmb-logo.svg";
    ImageSrc["FOOTER_EXPAND"] = "/fmk/styles/images/footer-expand.svg";
    ImageSrc["FOOTER_COLLAPSE"] = "/fmk/styles/images/footer-collapse.svg";
    ImageSrc["FORWARD"] = "/fmk/styles/images/forward.svg";
    ImageSrc["HELP"] = "/fmk/styles/images/help.svg";
    ImageSrc["HIDDEN"] = "/fmk/styles/images/hidden.svg";
    ImageSrc["INFO"] = "/fmk/styles/images/info.svg";
    ImageSrc["LIGHT_SPINNER"] = "/fmk/styles/images/light-spinner.svg";
    ImageSrc["LIGHT_SPINNER_ANIMATED"] = "/fmk/styles/images/light-spinner-animated.svg";
    ImageSrc["LOCK"] = "/fmk/styles/images/lock.svg";
    ImageSrc["MERGE"] = "/fmk/styles/images/merge.svg";
    ImageSrc["MISMATCH"] = "/fmk/styles/images/mismatch.svg";
    ImageSrc["PAUSED"] = "/fmk/styles/images/paused.svg";
    ImageSrc["PILL"] = "/fmk/styles/images/pill.svg";
    ImageSrc["PILL_TIME"] = "/fmk/styles/images/pill-time.svg";
    ImageSrc["PLUS"] = "/fmk/styles/images/plus.svg";
    ImageSrc["PRESCRIPTION"] = "/fmk/styles/images/prescription.svg";
    ImageSrc["PRESCRIPTION_CROSSED"] = "/fmk/styles/images/prescription-crossed.svg";
    ImageSrc["PRIVATE"] = "/fmk/styles/images/private.svg";
    ImageSrc["REFRESH"] = "/fmk/styles/images/refresh.svg";
    ImageSrc["REIMBURSEMENT_CODE_A"] = "/fmk/styles/images/reimbursement-code-a.svg";
    ImageSrc["REIMBURSEMENT_CODE_S"] = "/fmk/styles/images/reimbursement-code-s.svg";
    ImageSrc["REIMBURSEMENT_CODE_V"] = "/fmk/styles/images/reimbursement-code-v.svg";
    ImageSrc["REIMBURSEMENT_CODE_C"] = "/fmk/styles/images/reimbursement-code-c.svg";
    ImageSrc["READONLY_CHECKMARK_CHECKED"] = "/fmk/styles/images/readonly-checkmark-checked.svg";
    ImageSrc["READONLY_CHECKMARK_UNCHECKED"] = "/fmk/styles/images/readonly-checkmark-unchecked.svg";
    ImageSrc["RESIZE"] = "/fmk/styles/images/resize.svg";
    ImageSrc["SDS_LOGO"] = "/fmk/styles/images/sds-logo.svg";
    ImageSrc["SEARCH"] = "/fmk/styles/images/search.svg";
    ImageSrc["SEPARATOR"] = "/fmk/styles/images/separator.svg";
    ImageSrc["SETTINGS"] = "/fmk/styles/images/settings.svg";
    ImageSrc["STOP"] = "/fmk/styles/images/stop.svg";
    ImageSrc["SUPPORT"] = "/fmk/styles/images/support.svg";
    ImageSrc["TIME"] = "/fmk/styles/images/time.svg";
    ImageSrc["TRUNCATED"] = "/fmk/styles/images/truncated.svg";
    ImageSrc["USER"] = "/fmk/styles/images/user.svg";
    ImageSrc["VACCINE"] = "/fmk/styles/images/vaccine.svg";
    ImageSrc["VACCINE_EFFECTUATED"] = "/fmk/styles/images/vaccine-effectuated.svg";
    ImageSrc["VIEW"] = "/fmk/styles/images/view.svg";
})(ImageSrc = exports.ImageSrc || (exports.ImageSrc = {}));
//# sourceMappingURL=ImageSrc.js.map